document.addEventListener('DOMContentLoaded',function(){
  var t=document.querySelector('.menu-toggle'),n=document.querySelector('.nav');
  if(t&&n)t.addEventListener('click',function(){n.classList.toggle('open');t.setAttribute('aria-expanded',n.classList.contains('open'))});
  // product gallery thumbs
  document.querySelectorAll('.product__thumbs img').forEach(function(th){
    th.addEventListener('click',function(){
      var main=document.querySelector('.product__media .main-img');
      if(main){main.src=th.dataset.full;document.querySelectorAll('.product__thumbs img').forEach(function(i){i.classList.remove('active')});th.classList.add('active');}
    });
  });
});
